import { BarChart, Card, MIN_MODAL_CONTENT_HEIGHT } from "components";
import { useMemo, useState } from "react";
import { ChartExport, useExportableChart } from "shared/components";
import { useBuyingGroupInsight } from "../useBuyingGroupInsight";

interface BuyingGroupContactByJobLevelProps {
  campaignId: number;
}

export function BuyingGroupContactByJobLevel(
  props: BuyingGroupContactByJobLevelProps
) {
  const [isExpanded, setIsExpanded] = useState(false);
  const buyingGroupInsight = useBuyingGroupInsight(props.campaignId);
  const data = useMemo(
    () =>
      (buyingGroupInsight.data?.job_level_distribution ?? [])
        .filter((item) => item.contacts_per_job_level && item.job_level)
        .map((item) => ({
          // TODO: as unknown will be fixed by ts 5.5
          value: item.contacts_per_job_level as unknown as number,
          label: item.job_level as unknown as string,
        })),
    [buyingGroupInsight.data?.job_level_distribution]
  );

  const chart = useExportableChart({
    title: "Buying Group Contact By Job Level",
    campaignId: props.campaignId,
    chart: (
      <BarChart
        stretch
        data={data}
        orientation="vertical"
        valueAxisLabel="Contacts"
        maxXAxisHeight={70}
        minHeight={isExpanded ? MIN_MODAL_CONTENT_HEIGHT : undefined}
      />
    ),
  });

  return (
    <Card
      isLoading={buyingGroupInsight.isFetching}
      onExpandedChange={setIsExpanded}
      title={chart.title}
      hasData={!buyingGroupInsight.isFetching && data?.length > 0}
      isExpandable
      actions={
        <ChartExport
          size="small"
          campaignId={1}
          title={chart.title}
          onExportPNG={chart.downloadAsPng}
          data={data ?? []}
        />
      }
    >
      {chart.component}
      {chart.exportComponent}
    </Card>
  );
}
